import { FF_ENABLE_ESCRIPT_ORDERS } from '@/constants/featureFlags';
import { ESCRIPT_PRODUCT_DETAIL_PATH, PATIENT_PRODUCT_DETAIL_PATH } from '@/routes/route-paths';
import useFeatureFlags from '../useFeatureFlags';
import useCustomer from '../user/useCustomer';

export const useProductDetailsPath = () => {
  const { flags } = useFeatureFlags();
  const { data: customer } = useCustomer();
  const path =
    customer?.isExternal && flags[FF_ENABLE_ESCRIPT_ORDERS] ? ESCRIPT_PRODUCT_DETAIL_PATH : PATIENT_PRODUCT_DETAIL_PATH;

  return {
    path,
  };
};
